export const ConciergeConfig = {
  Helpdesk: `${process.env.REACT_APP_PATH}/concierge`,
  Directory: `${process.env.REACT_APP_PATH}/concierge/directory`,
};
